import { Redirect, Switch } from 'react-router-dom';

import { AppContainer } from 'twyne-new.ui';

export default function AppRouter({ children, redirect }) {
  return <>
    <AppContainer direction='vertical' className='min-h-0 min-w-0 overflow-hidden'>
      <Switch>
        {children}
        <Redirect to={redirect} />
      </Switch>
    </AppContainer>
  </>
}
